export const isValidForm = errors => !Object.values(errors).some(error => error.length > 0)
